import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const dismissRateCardReview = api(async function dismissRateCardReview({ id }) {
    return mutate(
        gql`
            mutation DismissRateCardReview($id: String!) {
                dismissRateCardReview(id: $id)
            }
        `,
        { id },
        { returns: "dismissRateCardReview" }
    )
})
